import { apiSlice } from 'src/features/api/api-slice';
import { BadgesData, ApiResponse } from 'src/common/interfaces';
import { RTKQueryTag } from 'src/common/constants';

export const badgesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBadges: builder.query<ApiResponse<BadgesData>, void>({
      query: () => `badges`,
      providesTags: [RTKQueryTag.Badges],
    }),
  }),
});

export const { useGetBadgesQuery } = badgesApiSlice;
